<script>

	import BlockEditor from "../../../../../../../js/common/canvas/editor/canvas/document/editors/BlockEditor";
    import Swal from 'sweetalert2';

	export default {

        extends: BlockEditor,

        data()
        {
            return {
				        triedToInitCkeditor: false,
                ckEditor: null,
                ckEditorToolCssElement: null,
                isDirty: false,

                rangeOnLastFocus: null,
                allowBlurOnce: false,
                mouseIsSelecting: false,
            };
        },

        created()
        {
        	this.tryToInitCkEditor();
        },

        methods: {

        	  // @ugly CKEditor cannot init in overview mode somehow.
        	  tryToInitCkEditor()
            {
            	// Abort due to already initted?
                if(this.triedToInitCkeditor || this.pageComponent.activeMode == 'overview')
                	return;

                //
                this.triedToInitCkeditor = true;

                //
                this.initEditing();
            },

            initEditing()
            {
                //
                this.manageEditing();

                this.initCkeditor();
            },

            manageEditing()
            {
            	this.element
                    .attr('contenteditable', this.blockSelectionEnabled);
            },

            initCkeditor()
            {
            	// Init CKEditor.
                CKEDITOR.inline(this.element.get(0), this.getCKEditorOptions());
            },

            getCKEditorOptions()
            {
                let options = {

                    extraPlugins: 'link,colorbutton,sourcedialog,justify,embed,autoembed,dialogadvtab',

                    // Needed so CKeditor doesn't remove image advanced by default
                    removeDialogTabs: '',

                    embed_provider: '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',

                    colorButton_colors: this.initTailwindConfigColors().join(','),

                    stylesSet: [],

                    versionCheck: false,

                    // Toolbar
                    toolbarGroups: [
                        { name: 'document', groups: [ 'mode', 'document', 'doctools', 'source', 'embed' ] },
                        { name: 'clipboard', groups: [ 'clipboard', 'undo' ] },
                        { name: 'editing', groups: [ 'find', 'selection', 'spellchecker', 'editing' ] },
                        { name: 'forms', groups: [ 'forms' ] },
                        { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
                        { name: 'paragraph', groups: [ 'list', 'indent', 'blocks', 'align', 'bidi', 'paragraph'] },
                        { name: 'link', groups: [ 'links' ] },
                        { name: 'insert', groups: [ 'insert' ] },
                        { name: 'styles', groups: [ 'styles', 'colors' ] },
                    ],
                    removeButtons: 'PasteFromWord,Paste,Copy,Replace,Find,SelectAll,Scayt,Form,Checkbox,Radio,Textarea,Select,TextField,Button,HiddenField,Save,Preview,Print,NewPage,Templates,Strike,Subscript,Superscript,RemoveFormat,CopyFormatting,Outdent,Indent,Blockquote,CreateDiv,JustifyBlock,Language,BidiRtl,BidiLtr,Anchor,Flash,HorizontalRule,PageBreak,Iframe,FontSize,Font,BGColor,ShowBlocks,Maximize,About,SpecialChar',

                    extraAllowedContent: 'iframe[*]; p a h2 h3 h4 h5(*)',

                    format_tags: 'p;h2;h3;h4;h5',

                    enterMode : CKEDITOR.ENTER_P,
                    shiftEnterMode: CKEDITOR.ENTER_BR,
                    autoParagraph: false,

                    language: 'nl',

                    on: {
                        instanceReady: this.onCkeditorLoaded,
                        blur: this.onCkeditorBlur,
                    },
                };

                // Apply app options.
                options = require('./../../../../../../../../../../../resources/components/common/canvas/blocks/utils/text/admin/ckEditorConfig.js')(options);

                //
                return options;
            },

            initTailwindConfigColors()
            {
                // Grab tailwind config
                let tailwindConfig = require('./../../../../../../../../../../../tailwind.config.js');

                // Get colors from config
                let tailwindConfigColors = Object.values(tailwindConfig.theme.extend.colors.palette);

                // Remove #'s from arrays
                tailwindConfigColors = tailwindConfigColors.map(color => color.replace('#', ''));

                // Add standard additional colors
                tailwindConfigColors = [
                  'ffffff',
                  '000000',
                  ...tailwindConfigColors,
                ];

                // Return colors array
                return tailwindConfigColors;
            },

			      setMouseDown(isDown)
            {
            	  // Abort due to not even selected?
                if(!this.isSelected)
                	return;

                // Set user as selecting (text) due to mouse is down?
                if(isDown)
				            this.mouseIsSelecting = true;

                // @ugly Since Selection is called later apparently.
                // Set as not, after some while.
                else
                	setTimeout(() => this.mouseIsSelecting = false, 100);
            },

            onCkeditorLoaded(event)
            {
            	  // Set
                this.ckEditor = event.editor;

                //
                CKFinder.setupCKEditor(this.ckEditor);

                // Listen for events.
                this.ckEditor.on('key', this.onKeyDown);
                this.ckEditor.on('focus', this.onFocus);
                this.ckEditor.on('change', this.onChange);

                //
                this.initMouseSelecting();

                //
                this.removeCkEditorTitle();
                this.manageCkEditorToolbarCss();
            },

            initMouseSelecting()
            {
                // Listen for mouse interaction on document.
                this.element
                    .mousedown(() =>
                    {
                      // Set mouse as down.
                      this.setMouseDown(true);

                      // Listen for mouse becoming up.
                      $(document).one('mouseup', () => this.setMouseDown(false));
                    });
            },

			      onCkeditorBlur()
            {
                // Reset allowBlurOnce.
                let allowBlurOnce = this.allowBlurOnce;;

                  this.allowBlurOnce = false;

                // Abort blur (keep toolbar shown) due to editor is (still) selected?
                if(!allowBlurOnce && this.isSelected)
                      return false;
            },

			      tryToDeselect()
            {
                // Mouse was selecting. Not intended to deselect this block.
                if(this.mouseIsSelecting)
                  return false;

                // Is dirty?
                else if(this.isDirty)
                {
                    //
                    this.blurCkeditor();

                    this.askForSave();
					// this.save();

                    // Avoid deselecting.
                    return false;
                }
                // No problem to deselect.
                else
                  return true;
            },

            async onNotSelectedAnymore()
			{
				// Relevant once the user had selected text, but choosed another block.
				this.clearSelection();

				//
                this.blurCkeditor();

				// Make contenteditable=false
				this.manageEditing();

				setTimeout(() => this.clearSelection(), 500);
			},

            // Calling clear selection via CKEditor was not sufficient.
            clearSelection()
            {
				if (window.getSelection) {
					if (window.getSelection().empty) {  // Chrome
						window.getSelection().empty();
					} else if (window.getSelection().removeAllRanges) {  // Firefox
						window.getSelection().removeAllRanges();
					}
				} else if (document.selection) {  // IE?
					document.selection.empty();
				}
            },

			async askForSave()
            {
                // Abort due to user does not confirm?
                const { value: confirmed } = await Swal.fire({
                    title: 'Wijzigingen niet opgeslagen.',
                    text: 'U heeft de content gewijzigd en niet op "Opslaan" geklikt. Wilt u alsnog de wijzingen opslaan?',
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonText: 'Ja, bewaren',
                    confirmButtonColor: '#55ce62',
                    cancelButtonText: 'Nee, verwijderen',
                });

                // Save or restore?
                confirmed ? this.save() : this.restore();
            },

            removeCkEditorTitle()
            {
                $(this.ckEditor).removeAttr('title');
            },

            onKeyDown()
            {
                // Prevent due to is saving thus we will loose the text soon it reloads the HTML.
                if(this.pageState.saving)
                    return false;
            },

            onFocus()
            {
            	// Is not selected yet? The alternative selection dropdown will be shown now.
            	if(!this.isSelected)
            	{
            		// Store range.
					this.setRangeOnLastFocus();

					// Blur
					this.ckEditor.focusManager.blur(true);
				}
            	// Is selected?
            	else {
					this.manageCkEditorToolbarCss();
					this.manageSaveButton();
				}
            },

            setRangeOnLastFocus()
            {
            	// @ugly Even listening to SelectionChange did not gave us the right range.
            	setTimeout(() => {

            		// Abort due to no ckeditor?
                    if(!this.ckEditor)
                    	return;

                    //
					this.rangeOnLastFocus = this.ckEditor.getSelection().getRanges()?.[0];

				}, 1);
			},

            onSelected()
            {
            	// Wait for the hover animation (scale) is down. Otherwise the toolbar will be positioned below the smaller rectangle instead of the original size.
            	setTimeout(() => this.restoreLastRange(), 500);

            	this.manageCkEditorToolbarCss();
                this.manageSaveButton();
            },

			/**
             * Restores last range.
             *
             * Needed for when user selected richtext editor, the selection alternative dropdown shows + blurs Ckeditor again, user chooses Ckeditor in dropdown, we restore the selection.
			 */
			restoreLastRange()
			{
				// Abort due to CKEditor not loaded (yet)?
				if(!this.ckEditor)
					return;

				// Focus again.
				this.ckEditor.focusManager.focus(true);

				// @ugly To make sure the toolbar is shown at the bottom instead on top.
				this.ckEditor.fire('focus');

                // @ugly Wait before we can set selection.
				setTimeout(() =>
                {
					if (this.rangeOnLastFocus)
						this.ckEditor.getSelection().selectRanges([this.rangeOnLastFocus]);
				}, 1);
            },

            // @ugly
            // TODO Medium: Remove, was for CKEditor 4?
            manageCkEditorToolbarCss()
            {
                // Abort due to not present?
                if(!this.ckEditor)
                    return;

                // Add css element to DOM?
                if(!this.ckEditorToolCssElement)
                    this.ckEditorToolCssElement = $('<style />').appendTo('body');

                // Hide due to not in right mode?
                if(this.pageComponent.activeMode == 'overview')
                    var css = 'display: none !important;';

                // Position on center?
                else if(window.getComputedStyle(this.element.get(0)).textAlign == 'center')
                    var css = ''; // TODO Must be relative to element.
                    //var css = 'left: 50% !important; right: auto !important; transform: translateX(-50%);';

                // Position on left?
                else
                    var css = '';
                    // TODO Must be relative to element.
                    //var css = //left: 5px !important; right: auto !important;';

                // Update CSS.
                this.ckEditorToolCssElement.text('#cke_' + this.ckEditor.name + ' { ' + css + ' }');
            },

            onChange()
            {
                //
                this.isDirty = true;

                //
                this.manageSaveButton();
            },

            manageSaveButton()
            {
            	// @ugly Sometimes ckEditor is null somehow?
                if(!this.ckEditor?.name)
                	return;

                // Get toolbar.
                let toolbar = $('#cke_' + this.ckEditor.name);

                //
                toolbar.css('display', 'flex');

                // Add button?
                let button = toolbar.find('.save');

                if(!button.length)
                    $('<button class="px-3 ml-2 btn btn-sm btn-success save" style="background: #55ce63; border: 1px solid #55ce63; border-radius: .2rem; color: white; font-size: .875rem; font-weight: 400; line-height: 1.5; padding: .25rem 1rem;" disabled>Opslaan</button>')
                        .click(() => this.save())
                        .hover(
                            event => $(event.currentTarget).css('opacity', .7),
                            event => $(event.currentTarget).css('opacity', 1)
                        )
                        .appendTo(toolbar);

                // (Un)set as disabled?
                button.attr('disabled', !this.isDirty);
            },

            blurCkeditor()
            {
            	// @ugly
				this.allowBlurOnce = true;

				// @ugly onCkeditorBlur might have disabled the blur before. Blurring again wont trigger the onCkeditorBlur() again. Focus first to let CKeditor be able to dispatch it blur event again.
				// Blur editor. Hide the toolbar.
				this.ckEditor.focusManager.focus(true);
				this.ckEditor.focusManager.blur(true);
            },

            save()
            {
            	// Deselect
                this.blurCkeditor();

                // Set. Reactivity makes sure it will get saved.
                this.$set(this.canvasBlock.options, 'html', this.element.html());

                // Set as not dirty anymore.
                this.isDirty = false;

				// Deselect
				this.pageComponent.selection.setSelection(null);
            },

            restore()
            {
            	// Set original HTML.
                this.element.html(this.canvasBlock.options?.html || '');

				// Set as not dirty anymore.
				this.isDirty = false;

				// Deselect
				this.pageComponent.selection.setSelection(null);
            },

        },

        watch: {

            'blockSelectionEnabled'()
            {
                this.manageEditing();
            },

            'pageComponent.activeMode'()
            {
            	this.tryToInitCkEditor();
                this.manageCkEditorToolbarCss();
            },

            'isSelected'(newVal)
			{
				// This editor is selected now?
                if (newVal)
                    this.onSelected();

                // Not selected anymore?
                else
                	this.onNotSelectedAnymore();
			},

        },

        computed: {

			isSelectable()
			{
				return true;
			},

        },

    }

</script>

<style lang="scss">

    // TODO Such CSS also applies on website! Move to block.scss or add mixin for [data-canvas-editable]?
    .galaxy\:\:common-canvas-blocks-utils-text-Block {
        outline: none !important;

        // Disabled by `.galaxy::common-canvas-editor-canvas-document-Page *`
        &,
        & * {
            user-select: auto !important;
        }
    }

</style>
